import api, { handleApiError } from './client';

export const maintenanceService = {
  /**
   * Recupera la lista degli utenti con ruolo athlete o parent (paginata).
   * @param {Object} params - { page, limit, search, role }
   */
  getPortalUsers: async (params = {}) => {
    try {
      const response = await api.get('/api/users', {
        params: {
          roles: params.role ? [params.role] : ['athlete', 'parent'],
          search: params.search || undefined,
          page: params.page || 1,
          limit: params.limit || 20,
          includeArchived: false,
        },
      });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Get portal users error:', error);
      return handleApiError(error, 'Errore nel caricamento degli utenti');
    }
  },

  /**
   * Avvia l'impersonificazione di un atleta/genitore.
   * Ritorna un token JWT temporaneo (1 ora) da usare nel nuovo tab.
   * @param {string} userId - GUID dell'utente da impersonificare
   */
  impersonateUser: async (userId) => {
    try {
      const response = await api.post(`/api/admin/impersonate/${userId}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Impersonate user error:', error);
      return handleApiError(error, "Errore nell'avvio dell'impersonificazione");
    }
  },
};

export default maintenanceService;
